import React, { useState, useEffect } from 'react';

// Configuração padrão estável para evitar re-render loop
const DEFAULT_AUDITORES = [];

const getCurrentDateString = () => {
  const d = new Date();
  return d.toISOString().split('T')[0];
};

function AddQualidadeTaskManualModal({
  isOpen,
  onClose,
  onAddTask,
  onUpdateTask,
  onDeleteTask,
  editingTask,
  userRole,
  userName,
  auditoresConfig = DEFAULT_AUDITORES, // Usa referência estável
  isPersonal = false
}) {
  const [titulo, setTitulo] = useState('');

  // Multiselect auditores
  const [selectedAuditores, setSelectedAuditores] = useState([]);

  const [data, setData] = useState(getCurrentDateString());
  const [horario, setHorario] = useState('09:00');
  const [urgencyLevel, setUrgencyLevel] = useState('nao_urgente_importante');

  // Novos campos de tempo
  const [horaInicioReal, setHoraInicioReal] = useState('');
  const [horaFimReal, setHoraFimReal] = useState('');

  const [agendarNaAgenda, setAgendarNaAgenda] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setIsDeleting(false); // Reseta modo exclusão ao abrir
      if (editingTask) {
        setTitulo(editingTask.titulo || '');

        if (editingTask.auditores && Array.isArray(editingTask.auditores)) {
          setSelectedAuditores(editingTask.auditores);
        } else {
          setSelectedAuditores(editingTask.auditor ? [editingTask.auditor] : []);
        }

        // Garante que é uma string válida
        setData(editingTask.data || getCurrentDateString());
        setHorario(editingTask.horario || '09:00');
        setUrgencyLevel(editingTask.urgencyLevel || 'nao_urgente_importante');

        setHoraInicioReal(editingTask.horaInicioReal || '');
        setHoraFimReal(editingTask.horaFimReal || '');

        setAgendarNaAgenda(!!editingTask.agendaId);
      } else {
        setTitulo('');
        // Default: o próprio usuário logado, se ele estiver na lista de auditores;
        // senão cai para o primeiro auditor (apenas se nao for pessoal)
        if (!isPersonal) {
          const souAuditor = auditoresConfig.some(a => a.name === userName);
          if (souAuditor) {
            setSelectedAuditores([userName]);
          } else if (auditoresConfig.length > 0) {
            setSelectedAuditores([auditoresConfig[0].name]);
          } else {
            setSelectedAuditores([]);
          }
        } else {
          setSelectedAuditores([]);
        }
        setData(getCurrentDateString());
        setHorario('09:00');
        setUrgencyLevel('nao_urgente_importante');
        setHoraInicioReal('');
        setHoraFimReal('');
        setAgendarNaAgenda(false);
      }
    }
  }, [isOpen, editingTask, auditoresConfig, isPersonal, userName]);

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!isPersonal && selectedAuditores.length === 0) {
      alert('Selecione pelo menos um responsável.');
      return;
    }

    const taskData = {
      titulo,
      auditor: selectedAuditores.length > 0 ? selectedAuditores[0] : (isPersonal ? userName : ''),
      auditores: selectedAuditores.length > 0 ? selectedAuditores : (isPersonal && userName ? [userName] : []),
      data: data, // Já está no formato correto de string
      horario,
      urgencyLevel,
      horaInicioReal,
      horaFimReal
    };

    if (editingTask) {
      onUpdateTask(editingTask, taskData);
    } else {
      onAddTask(taskData, agendarNaAgenda);
    }
    onClose();
  };

  const handleDelete = () => {
    onDeleteTask(editingTask.id);
    onClose();
  };

  const handeConfirmDeleteFlow = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (isDeleting) {
      handleDelete();
    } else {
      setIsDeleting(true);
    }
  };

  const handleDateChange = (e) => {
    // Agora só salva o valor direto (string YYYY-MM-DD) do input
    setData(e.target.value);
  };

  const toggleAuditorSelection = (name) => {
    setSelectedAuditores(prev => {
      if (prev.includes(name)) {
        return prev.filter(a => a !== name);
      } else {
        return [...prev, name];
      }
    });
  };

  const isUserPrivilegiado = userRole === 'admin' || userName === 'Alexandre';

  return (
    <div className="modal-overlay">
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>{editingTask ? 'Editar Tarefa Manual' : 'Adicionar Tarefa Manual'}</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Descrição da Tarefa</label>
            <input type="text" value={titulo} onChange={(e) => setTitulo(e.target.value)} required />
          </div>

          <div className="form-group">
            <label>Nível de Urgência (Matriz de Prioridade)</label>
            <select value={urgencyLevel} onChange={(e) => setUrgencyLevel(e.target.value)} required>
              <option value="urgente_importante">Urgente e Importante</option>
              <option value="nao_urgente_importante">Não Urgente e Importante</option>
              <option value="urgente_nao_importante">Urgente e Não Importante</option>
              <option value="nao_urgente_nao_importante">Não Urgente e Não Importante</option>
            </select>
          </div>

          {!isPersonal && (
            <div className="form-group">
              <label>Responsáveis</label>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '4px' }}>
                {auditoresConfig.length > 0 ? auditoresConfig.map(aud => {
                  const isActive = selectedAuditores.includes(aud.name);
                  return (
                    <div
                      key={aud.id}
                      onClick={() => toggleAuditorSelection(aud.name)}
                      className="auditor-checkbox-item"
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '6px',
                        padding: '6px 14px',
                        borderRadius: '20px',
                        border: `1.5px solid ${isActive ? aud.color : '#e2e8f0'}`,
                        background: isActive ? aud.color : '#f8fafc',
                        color: isActive ? '#fff' : '#64748b',
                        fontWeight: isActive ? '700' : '600',
                        fontSize: '0.82rem',
                        cursor: 'pointer',
                        transition: 'all 0.15s',
                        userSelect: 'none'
                      }}
                    >
                      {!isActive && (
                        <div style={{
                          width: '8px', height: '8px', borderRadius: '50%',
                          backgroundColor: aud.color
                        }} />
                      )}
                      {aud.name}
                    </div>
                  );
                }) : <p className="empty-msg-small">Sem auditores configurados.</p>}
              </div>
            </div>
          )}

          <div className="form-group-row">
            <div className="form-group">
              <label>Data</label>
              <input type="date" value={data} onChange={handleDateChange} required />
            </div>
            <div className="form-group">
              <label>Horário Previsto</label>
              <input type="time" value={horario} onChange={(e) => setHorario(e.target.value)} required />
            </div>
          </div>

          <div className="form-group-row" style={{ marginTop: '10px', borderTop: '1px solid #eee', paddingTop: '10px' }}>
            <div className="form-group">
              <label>Início Real</label>
              <input type="time" value={horaInicioReal} onChange={(e) => setHoraInicioReal(e.target.value)} />
            </div>
            <div className="form-group">
              <label>Término Real</label>
              <input type="time" value={horaFimReal} onChange={(e) => setHoraFimReal(e.target.value)} />
            </div>
          </div>

          {/* --- CHECKBOX CONDICIONAL --- */}
          {isUserPrivilegiado && (
            <div className="form-group">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  checked={agendarNaAgenda}
                  onChange={(e) => setAgendarNaAgenda(e.target.checked)}
                  disabled={!!editingTask?.agendaId}
                />
                Agendar esta tarefa na agenda principal?
              </label>
            </div>
          )}

          <div className="modal-actions">
            {(editingTask || isPersonal) && editingTask && (
              <button 
                type="button" 
                onClick={handeConfirmDeleteFlow} 
                className={isDeleting ? "btn-excluir confirmar-exclusao" : "btn-excluir"}
                style={isDeleting ? { backgroundColor: '#dc2626', color: 'white', fontWeight: 'bold' } : {}}
              >
                {isDeleting ? 'Tem certeza?' : 'Excluir'}
              </button>
            )}
            <div style={{ flexGrow: 1 }}></div>
            <button type="button" onClick={onClose} className="btn-cancel">Cancelar</button>
            <button type="submit" className="btn-save">{editingTask ? 'Salvar Alterações' : 'Salvar Tarefa'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddQualidadeTaskManualModal;